// src/lib/store/appStore.ts
import { writable } from 'svelte/store';

type State = { [key: string]: any };

const loadState = (): State => {
    try {
        const saved = localStorage.getItem('state');
        return saved ? JSON.parse(saved) : {};
    } catch {
        return {};
    }
};

const saveState = (state: State) => {
    localStorage.setItem('state', JSON.stringify(state));
};

const store = writable<State>(loadState());

store.subscribe(saveState);

const appStore = {
    subscribe: store.subscribe,

    /** Set or update a single field */
    set: (key: string, value: any) => {
        store.update(state => {
            state[key] = value;
            return state;
        });
    },

    /** Get a field (no reactividad) */
    get: (key: string): any => {
        const state = loadState();
        return state[key];
    },

    /** Remove a field from the store */
    delete: (key: string) => {
        store.update(state => {
            delete state[key];
            return state;
        });
    },

    /** Reset store to empty */
    reset: () => {
        localStorage.removeItem('state');
        store.set({});
    },

    /** List all keys currently stored */
    keys: (): string[] => {
        return Object.keys(loadState());
    },

    /** Remove keys that match a predicate */
    cleanup: (predicate: (key: string, value: any) => boolean) => {
        store.update(state => {
            for (const key of Object.keys(state)) {
                try {
                    if (predicate(key, state[key])) {
                        delete state[key];
                    }
                } catch {
                    // ignore predicate errors
                }
            }
            return state;
        });
    }
};

export default appStore;